import $ from 'jquery';
import { AuthType } from './auth';

const BASE_SELECTOR: string = '[data-auth]';
const BUTTON_SELECTOR: string = '.button'
const LOADING_CLASSNAME: string = 'loading';

// Data supplied by <script> tag in step_two.twig
declare global {
  interface Window {
    countryCodesRequiringUserPostalCode: string[];
    countryCodesRequiringUserFullAddress: string[];
  }
}

export class AuthUI {
  public url: string = this.$base.data('auth-url')

  public constructor(private $base: JQuery<HTMLElement>) {
  }

  /**
   * Intercept submit event
   * @param callback
   */
  public onSubmit(callback: () => void) {
    this.$base.on('submit', (e) => {
      e.preventDefault();
      callback();
    });
    return false;
  }

  /**
   * Detect if Login or Register
   * @return AuthType
   */
  public getAuthType(): AuthType {
    const type = this.$base.data('auth');

    switch (type) {
      case 'register':
        return AuthType.Register;
      case 'login':
        return AuthType.Login;
      case 'register-complete':
        return AuthType.RegisterComplete;
    }

    throw new Error('Unknown auth type ' + type);
  }

  /**
   * Return formular data
   * @return Array
   */
  public getData() {
    return this.$base.serializeArray();
  }

  /**
   * Method to show/hide a loading animation for the submit button
   * @param state
   */
  public enableLoading(state: boolean) {
    if (state) {
      this.$base.find(BUTTON_SELECTOR).addClass(LOADING_CLASSNAME);
    } else {
      this.$base.find(BUTTON_SELECTOR).removeClass(LOADING_CLASSNAME);
    }
  }

  /**
   * Check if the legal checkbox is checked
   */
  public isLegalChecked(): boolean {
    const data = this.getData();
    const legalBox = data.filter((value) => value.name === 'data[Register][confirm_terms]')
    if (legalBox.length > 0 && legalBox[0].value === '1') {
      return true;
    }

    return false;
  }

  public onCountryChange(): void {
    // Add event handler
    this.getRegisterFormInput('country').on('change', () => {
      this.toggleRegisterFormInputs();
    });

    // Trigger for initial state
    this.toggleRegisterFormInputs();
  }

  private getRegisterFormInput(name: string): JQuery<HTMLElement> {
    return this.$base.find(`[name="data[Register][${name}]"]`);
  }

  private enableRegisterFormInput(name: string): void {
    this.getRegisterFormInput(name).removeAttr('disabled').attr('required', 'required').show();
  }

  private disableRegisterFormInput(name: string): void {
    this.getRegisterFormInput(name).removeAttr('required').attr('disabled', 'disabled').hide();
  }

  private toggleRegisterFormInputs(): void {
    const countryCode = this.getRegisterFormInput('country').val();

    if ($.inArray(countryCode, window.countryCodesRequiringUserPostalCode) > -1 || $.inArray(countryCode, window.countryCodesRequiringUserFullAddress) > -1) {
      this.enableRegisterFormInput('postalCode');
    } else {
      this.disableRegisterFormInput('postalCode');
    }

    if ($.inArray(countryCode, window.countryCodesRequiringUserFullAddress) > -1) {
      this.enableRegisterFormInput('locality');
      this.enableRegisterFormInput('street');
    } else {
      this.disableRegisterFormInput('locality');
      this.disableRegisterFormInput('street');
    }
  }
}

export function createAuthUIInstances(): AuthUI[] {
  const elements = $(BASE_SELECTOR);
  let instances: AuthUI[] = [];

  elements.each((index, el) => {
    instances.push(new AuthUI($(el)));
  });

  return instances;
}
